import * as React from 'react'
import * as Common from '@tfo/common'
import { observer } from 'mobx-react'
import { injectIntl, FormattedMessage } from 'react-intl'
import classnames from 'classnames'
import './ReportCard.scss'
import { Elements, TextButton, InfoButton } from '@tfo/common'
import LinesEllipsis from 'react-lines-ellipsis'
const { Heading3, Heading5, Label, Paragraph } = Elements
export interface ReportCardProps {
	data: Common.models.ReportPackage
	proceedToOrderCallback: Function
	openDetailsCallback: Function
}

const ReportCard = (props: any) => {
	const { customName, daysToDeliver, available, checkpoints, description } = props.data
	const internationalReportPackage = checkpoints.some(x => x === 'Countries')

	const proceedToOrder = (e: any) => {
		if (!available) {
			return
		}
		e.stopPropagation()
		props.proceedToOrderCallback(props.data)
	}
	const openDetails = (e: any) => {
		e.stopPropagation()
		props.openDetailsCallback(props.data)
	}

	const daysTextId = daysToDeliver < 2 ? 'neworder.day' : 'neworder.days'
	const buttonTextId = available ? 'neworder.cta.order' : 'neworder.cta.notAvailable'
	const bodyTextId = 'neworder.body.temporarilyEmpty'
	const internationalBodyTextId = 'neworder.days.international'
	const daysText = props.intl.formatMessage({ id: daysTextId })
	const buttonText = props.intl.formatMessage({ id: buttonTextId })
	const bodyText = props.intl.formatMessage({ id: bodyTextId })
	const internationalDaysText = props.intl.formatMessage({ id: internationalBodyTextId }, { num: daysToDeliver })

	return (
		<div
			className={classnames('ReportCard', {
				'ReportCard--disabled': !available,
			})}
			onClick={proceedToOrder}>
			<div className={'ReportCard__FoldRight'} />
			<div className={'ReportCard__Outer'}>
				<div className={'ReportCard__Inner'}>
					<div>
						<div className={'ReportCard__LabelAndInfoBtn'}>
							<Label className={'ReportCard__Label1'}>
								{props.intl.formatMessage({ id: 'common.typeofreport' })}
							</Label>
							{!internationalReportPackage &&
								<InfoButton className={'ReportCard__InfoBtn'} small onClick={openDetails} />}
						</div>
						<div className={'ReportCard__Heading'}>
							<Heading3>{customName}</Heading3>
						</div>
						<div>
							<Paragraph>
								{description}
							</Paragraph>
						</div>
						<LinesEllipsis
							component={'p'}
							className={'Paragraph Paragraph--Small'}
							text={bodyText}
							maxLine={5}
							ellipsis={'...'}
							trimRight
							basedOn={'letters'}
						/>
					</div>
					<div>
						<Label>
							{!internationalReportPackage ?
								<FormattedMessage id={'neworder.caption'} /> : <FormattedMessage id={'neworder.caption.international'} />}
						</Label>
						<Heading5>
							{!internationalReportPackage ?
								`${daysToDeliver} ${daysText}` :
								`${internationalDaysText} `
							}
						</Heading5>

					</div>
				</div>
			</div>
			<TextButton disabled={!available} onClick={proceedToOrder}>
				{buttonText}
			</TextButton>
		</div>
	)
}

export default injectIntl(observer(ReportCard))
